import { gql } from '@apollo/client';
/**
 * Overview of a search: the exact size of every bucket plus its first rows.
 *
 * The preview under the header field and the first render of the results
 * screen share this document AND its `limit`, so navigating from one to the
 * other is served straight from the Apollo cache.
 *
 * @const GlobalSearchQuery
 * @since 1.0.0
 */
export const GlobalSearchQuery = gql `
  query GlobalSearchQuery($input: GlobalSearchInput!) {
    globalSearch(input: $input) {
      search
      total
      partial
      groups {
        entity
        count
        items {
          entity
          uuid
          title
          subtitle
          code
          excerpt
          status
          parentEntity
          parentUuid
        }
      }
    }
  }
`;
